(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-localstorage-listener', actionFunc);

    function actionFunc($q, lodash, $rootScope) {
        return function(options, actionData, eventData) {
            var event_key = lodash.get(options, 'event', 'listening-for-localstorage-changes');
            var next_event = lodash.get(options,'next_event', null);
            var initialValue = '1';
            localStorage.setItem(event_key, initialValue);
            return $q.when(run());
            function run() {
                window.onstorage = function(e) {
                    if (e.key == event_key && e.newValue != initialValue && e.newValue != e.oldValue) {
                        window.onstorage = null;
                        localStorage.removeItem(event_key);
                        $rootScope.$broadcast(next_event, actionData, eventData);
                    }
                }
                return true;
            }
        };
    }
})();